import React from "react";
import { IconOptions } from "./utils/iconOptions";
import { classNames } from "./utils/classNames";
export const Avatar = ({ text, loading, img, icon, size, }) => {
    const firstChar = () => {
        if (text)
            return text.charAt(0);
        return undefined;
    };
    if (loading) {
        return React.createElement("div", { className: "avatar avatar--loading" });
    }
    const iconType = icon && IconOptions[icon].type === "pro" ? "glyphicon-pro" : "glyphicon";
    const iconValue = icon && IconOptions[icon].value;
    return (React.createElement("div", { className: classNames("avatar", img ? "avatar--img" : "avatar--static", size ? `avatar--${size}` : ``) },
        img && (React.createElement("div", { style: {
                backgroundImage: `url(${img})`,
            } })),
        !img && React.createElement("span", null, firstChar()),
        icon && (React.createElement("span", { className: `icon ${iconType} ${iconType}-${iconValue}` }))));
};
